import React, { Component } from 'react';
//import d3 from 'd3';

export class GenericBarLabel extends Component {
  getWidth() {
    const { xTickValues, index } = this.props;

    return xTickValues[index + 1]
      ? xTickValues[index + 1] - xTickValues[index]
      : 'auto';
  }

  componentDidUpdate() {
    const { text } = this.props;

    const tspan = this.label.childNodes[0];
    const textLength = tspan.getComputedTextLength();
    const availableWidth = this.getWidth();
    if (textLength > availableWidth) {
      const ratio = availableWidth / textLength;
      const newLength = Math.floor(text.length * ratio) - 2;
      const truncated = text.substring(0, newLength) + '...';
      tspan.innerHTML = truncated;
    }
  }

  render() {
    const { x, y, text, textAnchor, style } = this.props;

    return (
      <text ref={r => (this.label = r)} x={x} y={y} dy="11">
        <tspan x={x} dx="0" textAnchor={textAnchor} style={style}>
          {text}
        </tspan>
      </text>
    );
  }
}
export default GenericBarLabel;



// WEBPACK FOOTER //
// ./src/components/GenericBarChart/GenericBarLabel.jsx